// extracted by mini-css-extract-plugin
export default {"box":"retailerFilterPage_box__+ghNr","box__content":"retailerFilterPage_box__content__4IMgD"};